import { IFormPackage } from "../../types/formAssignments/packages/IFormPackage";
import { TMenuOption } from "./TMenuOption";
import { EActiveStatus } from "../../types/formsTable";

export const generatePackageOptions = (
  assignedPackagedIds: string[],
  packages: IFormPackage[],
  onSelectPackage: (formPackage: IFormPackage) => void
): TMenuOption[] => {
  const filteredPackages = packages?.filter(
    (formPackage) =>
      !formPackage?.forms?.every(
        (form) => form?.activeStatus === EActiveStatus.Inactive
      )
  );

  return filteredPackages.map((formPackage) => ({
    label: formPackage.name,
    callBack: () => {
      onSelectPackage(formPackage);
    },
    disabled:
      !formPackage.forms.length || assignedPackagedIds.includes(formPackage.id),
  }));
};
